class CartLp extends HTMLElement {
  constructor() {
    super();
    
    // Listen for cart update events
    subscribe('cart-update', (eventData) => {
      if (eventData && eventData.cartData) {
        this.updateCartCount(eventData.cartData);
      }
    });
  }
  
  connectedCallback() {
    // Add click event listener when element is connected to DOM
    this.addEventListener('click', this.handleClick.bind(this));
  }
  
  disconnectedCallback() {
    // Clean up event listener when element is removed
    this.removeEventListener('click', this.handleClick.bind(this));
  }
  
  handleClick(event) {
    if (this.classList.contains('open-drawer')) {
        document.querySelector('cart-drawer')?.open();
      // You might want to prevent default behavior if needed
      // event.preventDefault();
    } else {
      // Redirect to cart URL
      if (window.routes && window.routes.cart_url) {
        window.location.href = window.routes.cart_url;
      } else {
        console.warn('Cart URL not found in window.routes.cart_url');
      }
    }
  }

  updateCartCount(cartData) {
    // Get the cart-icon-bubble HTML from sections
    const cartIconBubbleHTML = cartData.sections?.['cart-icon-bubble'];
    
    if (!cartIconBubbleHTML) {
      console.warn('cart-icon-bubble HTML not found in cartData.sections');
      return;
    }
    
    // Create a temporary container to parse the HTML
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = cartIconBubbleHTML;
    
    // Find the cart-count-bubble in the new HTML
    const newCartBubble = tempContainer.querySelector('.cart-count-bubble');
    
    if (!newCartBubble) {
      console.warn('.cart-count-bubble element not found in cart-icon-bubble HTML');
      return;
    }
    
    // Find the existing cart-count-bubble in our component
    const existingCartBubble = this.querySelector('.cart-count-bubble');
    
    if (existingCartBubble) {
      // Replace the content of the existing bubble with the new content
      existingCartBubble.innerHTML = newCartBubble.innerHTML;
    } else {
      // If no existing bubble, append the new one
      this.appendChild(newCartBubble);
    }
  }
}

// Register the web component
customElements.define('cart-lp', CartLp);